import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const bgParallaxElms = document.querySelectorAll('.js-bgParallax');
  if(bgParallaxElms.length !== 0) {
    bgParallaxElms.forEach((elm) => {
      const img = elm.querySelector('picture');
      let percent =  elm.dataset.percent ? parseInt(elm.dataset.percent) : 30;
      gsap.fromTo(
        img,
        {
          yPercent: -percent / 2,
        },
        {
          yPercent: percent / 2,
          ease: "none",
          scrollTrigger: {
            name: "parallax",
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            markers: false,
            scrub: true,
          },
        }
      );
    });
  }
}

const resize = () => {
  // const bgParallaxElms = document.querySelectorAll('.js-bgParallax');
  // bgParallaxElms.forEach((elm) => {
  //   const img = elm.querySelector('picture');
  //   let percent = 20;
  //   gsap.fromTo(
  //     img,
  //     {
  //       yPercent: percent / 2,
  //     },
  //     {
  //       yPercent: -percent / 2,
  //       ease: "none",
  //       scrollTrigger: {
  //         name: "parallax",
  //         trigger: img,
  //         start: "top bottom",
  //         end: "bottom top",
  //         markers: false,
  //         scrub: true,
  //       },
  //     }
  //   );
  // });
}

export {
  init,
  resize,
};